import intl from 'react-intl-universal'

export default [
  {
    text: intl.get('Tabs.planning'),
    id: 'tab-planning',
    settingsKey: 'planning',
  },
  {
    text: intl.get('Tabs.circulate'),
    id: 'tab-circulate',
    settingsKey: null,
  },
  {
    text: intl.get('Tabs.compose'),
    id: 'tab-compose',
    settingsKey: null,
  },
  {
    text: intl.get('Tabs.meta'),
    id: 'tab-meta',
    settingsKey: 'metas',
  },
  {
    text: intl.get('Tabs.featuredImage'),
    id: 'tab-promo',
    settingsKey: 'promo',
  },
]
